<template>
    <va-create-layout>
        <RentalTransactionEvent-form
            :title="title"
            :item="item"
        ></RentalTransactionEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
